<template>
  <div class="row mb-8">
    <div class="col-md-10 p-1 mb-9">
      <div class="position-relative h-150px bg-secondary rounded">
        <DropImageZone id="event-cover" :file="formData.banner" @addFile="getBanner" @removeFile="removeBanner" />

        <div class="position-absolute bottom-0 mb-n20 ms-10">
          <div class="d-flex flex-row align-items-end">
            <div class="rounded-circle h-125px w-125px bg-light shadow me-9">
              <DropImageZone class="rounded-circle" id="event-img" circle :file="formData.logo" :edit="false" @addFile="getEventLogo" @removeFile="removeEventLogo" />
            </div>
            <div class="pt-5">
              <h3 class="fs-1 fw-bolder mb-0 me-3">{{ event?.title }}</h3>
              <div class="d-flex align-items-center flex-wrap" v-if="$can(abilities.CAN_SEND_EVENT_INVITATAION)">
                <div id="kt_clipboard_4" class="me-5 text-muted fw-volder fs-3">{{ shortenLink(event.invitation_link) }}</div>
                <button class="btn btn-icon btn-sm btn-light me-3 btn-cpy" :data-clipboard-text="event.invitation_link">
                  <i class="bi bi-clipboard text-primary "></i>
                </button>
                <a :href="event.invitation_link" target="_blank" class="btn btn-icon btn-sm btn-light me-3">
                  <i class="bi bi-box-arrow-up-right text-primary "></i>
                </a>
                
                <div class="dropdown">
                  <a class="btn btn-icon btn-sm btn-light" :title="$t('events.send_message')" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="far fa-paper-plane text-primary"></i>
                  </a>
                  <ul class="dropdown-menu">
                      <li style="cursor: pointer;" @click="openSendMail"><a class="dropdown-item">{{ $t('events.by_mail') }}</a></li>
                      <li style="cursor: pointer;" @click="openSendWhatsapp"><a class="dropdown-item">{{ $t('events.by_whatsapp') }}</a></li>
                      <li style="cursor: pointer;" @click="openSendImport"><a class="dropdown-item">{{ $t('events.by_import') }}</a></li>
                  </ul>
                </div>
                <a
                    @click.prevent="openSwal"
                    class="btn btn-icon btn-sm btn-light me-3"
                    href="#"
                >
                  <i class="bi bi-box-arrow-up-right text-primary"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2 p-1 ps-2">
      <div style="margin: auto 0;">
        <Button btn-class="btn-md mb-5 w-100" type="new" btn-text="events.qrcode" style="cursor: pointer;" @click="openQrcodeModal"></Button>
        <div class="d-flex mb-5">
          <a :href="yourWebsite" target="_blank" :title="$t('events.visite')" class="btn btn-md btn-primary me-3" style="cursor: pointer; width: 75% !important;">
            {{ $t('events.your_website') }}
          </a>
          <button class="btn btn-icon btn-md me-3 mini-link-cpy" :title="$t('events.copied')" style="background-color: var(--bs-gray-200) !important; cursor: pointer;" :data-clipboard-text="yourWebsite">
            <i class="bi bi-clipboard text-primary"></i>
          </button>
          <button class="btn btn-icon btn-md" :title="$t('events.config_website')" style="background-color: var(--bs-gray-200) !important; cursor: pointer;" @click="openLinkModal">
            <i class="fas fa-cog text-primary"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <SendMessage id="send_message_to_invite_modal" @load="loadInvitation"/>
  <SendMessageWhatsapp id="send_message_to_invite_whatsapp_modal"  @load="loadInvitation"/>

  <QrCodeModal id="event_qrcode_modal" :title="$t('events.qrcode')" :to-encode="event?.joinLink" name="planning_qrcode" />

  <div class="modal fade" id="send_message_to_invite_import_modal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="sendImport" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('events.import_list_invitation') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="openSendImport">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body">
            <Button btn-class="btn-md mb-5 w-100" type="new" iconClass="fas fa-download me-2" btn-text="events.download_model" @click="downloadExcel" :is-loading="isLoadingDownload"></Button>
            <InputFileIcon
                containerClass="col-12"
                :name="`events-import-invitation`"
                :label="$t('events.enter_import_file')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-sm form-control-solid'"
                :isRequired="true"
                size="lg"
                :placeholder="$t('events.import_file')"
                v-model="formImport.file"
            />
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="openSendImport"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingImport"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal fade" id="event_link_modal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('events.link') }}</h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="openLinkModal">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
          </div>
        </div>

        <div class="modal-body">
          <h3 class="mb-5">{{ $t('events.text_link') }}</h3>
          <h5 class="mb-5">{{ $t('events.default_link') }} <a :href="event?.website_link_default" target="_blank">{{ event?.website_link_default }}</a></h5>
          <Input
            container-class="mt-5"
            :name="`event_websiteLink`"
            type="url"
            :label="$t('events.website_link')"
            labelClass="form-label fs-6 text-black"
            :inputClass="'form-control form-control-lg form-control-solid'"
            size="lg"
            :isRequired="false" 
            v-model="websiteLink"
            :placeholder="$t('events.website_link')"
          />
        </div>
        <div class="modal-footer">
          <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="openLinkModal"></Button>
          <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" @click="saveWebsiteLink" :is-loading="isLoading"></Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, watch, onMounted} from "vue";
import DropImageZone from "@/Modules/Events/components/DropImageZone.vue";
import {useStore} from "vuex";
import {createFormData} from "@/mixins/Helpers";
import SendMessage from "./modals/SendMessage.vue";
import SendMessageWhatsapp from "./modals/SendMessageWhatsapp.vue";
import {useRoute , useRouter} from "vue-router";
import InputFileIcon from "@/components/InputFileIcon"
import Button from "@/components/Button";
import abilities from "@/composables/abilities";
import Input from "@/components/Input.vue"
import QrCodeModal from "./Modal/QrCodeModal.vue";
import i18n from "@/plugins/i18n";
import {useSwal} from "@/composables/useSwal";
import { getTenantId } from '@/mixins/Helpers';
import { computed } from "vue";

const store = useStore()
const route = useRoute();
const router = useRouter()
const emits = defineEmits(["invitation"])

const props = defineProps({
  event: { type: Object, default: () => ({
      id: '',
      banner: null,
      logo: null
  }) },
})
const {showSwal} = useSwal()

const formData = ref(props.event);
const isLoadingImport = ref(false);
const isLoading = ref(false);
const formImport = ref({
  event_id: '',
  file: null
})
const isLoadingDownload = ref(false)
const websiteLink = ref(props.event?.website_link)
const yourWebsite = ref(props.event?.website_link || props.event?.website_link_default)
const isSenakponTenant = ref(false)

const openSwal = () => {
  Swal.fire({
    title:  i18n.global.t('events.swal.thank_mail'),
    text: i18n.global.t('events.swal.send_thank_mail'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText:  i18n.global.t('events.swal.send'),
    cancelButtonText:  i18n.global.t('events.swal.cancel'),
  }).then((result) => {
    if (result.isConfirmed) {
      store.dispatch('events/sendThanksEmail', route.params.id).then(res => {
        window.toastr['success'](i18n.global.t("notification.pipeline_created"))
      })
    }
  })
}
function getBanner(logo) {
  const formDataPayload = createFormData({banner: logo, event_id: props.event.id});
  formDataPayload.append("_method", "POST")

  store.dispatch('events/changeEventBanner', {id: formData.value.id, data: formDataPayload})
      .then(() => {
        window.toastr['success'](i18n.global.t('notification.event_banner_changed'))
        formData.value.banner = {
          file: logo,
          name: logo.name,
          type: logo.type,
          size: logo.size,
          url: URL.createObjectURL(logo),
        };
      })
      .catch(() => {

      })
}

function loadInvitation() {
  emits('invitation')
}

function getEventLogo(logo) {
  const formDataPayload = createFormData({logo: logo, event_id: props.event.id});
  formDataPayload.append("_method", "POST")

  store.dispatch('events/changeEventLogo', {id: formData.value.id, data: formDataPayload})
      .then(() => {
        window.toastr['success'](i18n.global.t('notification.event_logo_changed'))
        formData.value.logo = {
          file: logo,
          name: logo.name,
          type: logo.type,
          size: logo.size,
          url: URL.createObjectURL(logo),
        };
      })
      .catch(() => {

      })
}

function removeBanner() {
  formData.value.banner = null;
}

function removeEventLogo() {
  formData.value.logo = null;
}

function shortenLink(link) {
  if (!link) return '';

  const maxLength = 50;

  if (link.length <= maxLength) return link;

  const start = link.substring(0, 25);
  const end = link.substring(link.length - 20);

  return `${start}...${end}`;
}

function openSendMail() {
  $('#send_message_to_invite_modal').modal('toggle')
}

function openSendWhatsapp() {
  $('#send_message_to_invite_whatsapp_modal').modal('toggle')
}

function openSendImport() {
  $('#send_message_to_invite_import_modal').modal('toggle')
}

function openQrcodeModal() {
  $('#event_qrcode_modal').modal('toggle')
}

function openLinkModal() {
  $('#event_link_modal').modal('toggle')
}

function sendImport() {
  isLoadingImport.value = true;
  formImport.value.event_id = route.params.id

  store
    .dispatch('events/sendImportInvitation', formImport.value)
    .then(() => {
        isLoadingImport.value = false;
        openSendImport()
        loadInvitation()
        window.toastr["success"](i18n.global.t('events.send_invitation_import_successfully'));
    })
    .catch((e) => {
        isLoadingImport.value = false;
    });
}

function saveWebsiteLink() {
  isLoading.value = true;
  store
    .dispatch('events/saveWebsiteLink', {event_id: route.params.id, website_link: websiteLink.value})
    .then(() => {
        isLoading.value = false;
        openLinkModal()
        window.toastr["success"](i18n.global.t('events.saved_link_successfully'));
    })
    .catch((e) => {
        isLoading.value = false;
    });
}

const downloadExcel = async () => {
    try {
      isLoadingDownload.value = true
      const downloadLink = document.createElement('a');
      downloadLink.href = '/assets/media/excel/invitations_civilite.xlsx';
      downloadLink.download = 'Invitation_contacts.xlsx';
      downloadLink.click();
    } catch (e) { }
    isLoadingDownload.value = false
} 

 onMounted(() => {
    isSenakponTenant.value = getTenantId()?.slice(0, -1).toLowerCase() === 'senakpon'
  })

  function navigateToGoogleForm (){
    router.push({name: 'event-participator-google-register', params: {id: route.params.id}})
  }
</script>

<style>
  .customQR div:has(button.qr-code-btn) {
    display: flex!important;
    align-items: center!important;
    justify-content: center!important;
  }
</style>